/** Shared right-column width for policy input controls in a section row. */
export const POLICY_CONTROL_WIDTH = 'w-36'
